import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Presentation } from './components/Presentation';
import { PaletteCategories } from './components/PaletteCategories';
import { InterventionZones } from './components/InterventionZones';
import { Services } from './components/Services';
import { RSE } from './components/RSE';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-dark" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Presentation data-id="element-4" />
        <PaletteCategories data-id="element-5" />
        <InterventionZones data-id="element-6" />
        <Services data-id="element-7" />
        <RSE data-id="element-8" />
        <ContactForm data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}